const getMarketValue = (item: any, tickData: any) =>
  `${tickData?.[item.mt5Symbol || item.symbol]?.["Ask"]} / ${tickData?.[item.mt5Symbol || item.symbol]?.["Bid"]}`;

export const normalizeDiscoveryItems = (
  items: any[],
  tickData: any,
  nameProp = "mt5Name",
) =>
  items
    .map((item) => ({
      ...item,
      name: item[nameProp],
      code: item.mt5Symbol,
      image: item.trendingImage || item.image,
      value: getMarketValue(item, tickData),
    }))
    .filter((item) => !item?.value?.error);
